import React from 'react';

/**
 * Linkify URLs inside a free-text message.
 *
 * Sprint 1.0b-γ fix F23.1/2 — share button DM messages contain raw URLs that
 * users couldn't click. We now render http/https URLs as <a> tags while
 * keeping every other character intact (line breaks preserved by upstream
 * whitespace-pre-wrap class).
 *
 * Intentionally conservative regex: only matches `http://` and `https://`
 * followed by non-whitespace characters and stops before trailing punctuation
 * like `.`, `,`, `)` that's usually NOT part of the URL.
 */
const URL_REGEX = /(https?:\/\/[^\s<>"']+[^\s<>"'.,;:!?)\]])/gi;

export const linkifyText = (text) => {
  if (!text) return null;
  const parts = String(text).split(URL_REGEX);
  return parts.map((part, i) => {
    if (URL_REGEX.test(part)) {
      // Reset regex state because .test() is stateful with /g flag
      URL_REGEX.lastIndex = 0;
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-600 underline hover:text-cyan-700 break-all"
        >
          {part}
        </a>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

export default linkifyText;
